import { render } from "./CustomerSettings.vue?vue&type=template&id=12248fea"
import script from "./CustomerSettings.vue?vue&type=script&lang=js"
export * from "./CustomerSettings.vue?vue&type=script&lang=js"

import "./CustomerSettings.vue?vue&type=style&index=0&id=12248fea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__